import {Tag} from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const PendingTag = styled(Tag)`
  padding: 8px;
`;
